import React from 'react';
import { useTranslation } from 'react-i18next';
import { OPEN_EMS_UI_URL } from '../../utils/openEmsUrls';
import { getB2bSolarCaseCopy } from './b2bSolarCaseCopy';
import dayNightFigure from './solar-case-day-night.jpg';
import styles from './B2bSolarCase.module.css';

export default function B2bSolarCase() {
  const { i18n } = useTranslation();
  const copy = getB2bSolarCaseCopy(i18n.resolvedLanguage || i18n.language);
  const openEmsHref = `${OPEN_EMS_UI_URL.replace(/\/+$/, '')}/`;

  return (
    <article className={styles.case}>
      <img className={styles.figure} src={dayNightFigure} alt={copy.figureAlt} />
      <h3 className={styles.headline}>{copy.headline}</h3>
      <p className={styles.body}>
        {copy.introBefore}
        <a href={openEmsHref} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
          {copy.emsName}
        </a>
        {copy.introAfter}
      </p>
      <p className={styles.lead}>{copy.lead}</p>

      <section>
        <h4 className={styles.sectionTitle}>{copy.wasTitle}</h4>
        {copy.wasBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.changedTitle}</h4>
        {copy.changedBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.demandTitle}</h4>
        {copy.demandBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.betterTitle}</h4>
        {copy.betterBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <caption className={styles.caption}>{copy.tableCaption}</caption>
          <thead>
            <tr>
              <th scope="col">{copy.colMonth}</th>
              <th scope="col">{copy.colKwh}</th>
              <th scope="col">{copy.colPaid}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">{copy.july}</th>
              <td>{copy.julyKwh}</td>
              <td>{copy.julyPaid}</td>
            </tr>
            <tr>
              <th scope="row">{copy.august}</th>
              <td>{copy.augustKwh}</td>
              <td>{copy.augustPaid}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className={styles.body}>{copy.quoteAfter}</p>
      <p className={styles.source}>{copy.source}</p>
    </article>
  );
}
